import * as React from "react";

import type { DesignaliProps } from "../../types";

export const Nextjs = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="7.9"
        fill="currentColor"
        viewBox="0 0 24 7.9"
        {...props}
        ref={forwardedRef}
      >
        <path
          strokeWidth={0}
          d="M21.96,5.5s-.01.05-.02.07c-.05.15-.15.24-.29.3-.24.09-.47.09-.7-.01-.19-.08-.28-.23-.29-.44,0,0,.02,0,.02,0,.08,0,.17,0,.25,0,.01,0,.03.01.03.02.02.14.12.2.25.23.11.02.21.02.31-.03.03-.02.06-.04.09-.06.08-.09.07-.22-.04-.28-.07-.04-.16-.06-.23-.09-.12-.04-.24-.07-.35-.11-.11-.04-.2-.12-.24-.23-.08-.21,0-.43.21-.55.24-.13.49-.13.74-.01.14.07.23.19.25.35,0,0,0,.02,0,.02,0,0,0,.01,0,.02h-.29c-.03-.15-.14-.21-.28-.22-.08,0-.16,0-.23.04-.07.04-.12.09-.12.18,0,.08.04.14.11.17.09.04.18.06.27.09.12.03.24.06.34.13.11.07.19.16.21.3,0,0,0,0,0,.01v.12Z"
        />
        <path
          strokeWidth={0}
          d="M9.57,1.95v.64h-2.78v1.03h2.23v.64h-2.23v1.06h2.78v.64h-.05c-1.11,0-2.21,0-3.32,0-.3,0-.6,0-.89,0-.03,0-.05,0-.07-.03-.83-1.03-1.65-2.05-2.48-3.08,0-.01-.02-.02-.03-.04v3.14h-.69V1.95s.02,0,.03,0c.26,0,.53,0,.79,0,.02,0,.04,0,.06.03,1.05,1.3,2.1,2.61,3.15,3.91,0,0,.02.02.03.04V1.95h3.47Z"
        />
        <path
          strokeWidth={0}
          d="M12.47,3.39c.1-.12.19-.24.29-.36.28-.35.57-.7.85-1.05.02-.02.03-.03.06-.03.28,0,.55,0,.83,0,0,0,.02,0,.03,0-.54.67-1.07,1.33-1.61,2,.54.67,1.07,1.33,1.61,2-.02,0-.03,0-.03,0-.28,0-.56,0-.83,0-.02,0-.04,0-.06-.03-1.06-1.31-2.12-2.63-3.17-3.94,0,0-.02-.02-.03-.04.02,0,.03,0,.04,0,.28,0,.55,0,.83,0,.02,0,.04.01.05.03.38.46.75.93,1.12,1.39,0,0,.01.01.02.02Z"
        />
        <path
          strokeWidth={0}
          d="M16.69,5.95v-3.36h-1.4v-.64h3.47v.64h-1.37v3.36h-.69Z"
        />
        <path
          strokeWidth={0}
          d="M12.23,4.81c-.15.19-.3.37-.44.55-.15.19-.31.38-.46.57-.01.01-.03.02-.05.02-.28,0-.56,0-.84,0,0,0-.01,0-.03,0,.46-.57.92-1.14,1.37-1.71.15.19.3.37.45.56Z"
        />
        <path
          strokeWidth={0}
          d="M19.31,5.47h.3c0,.08.03.14.1.18.16.1.34,0,.36-.18,0-.03,0-.06,0-.09,0-.36,0-.72,0-1.08v-.05h.3s0,.02,0,.03c0,.38,0,.76,0,1.14,0,.25-.13.43-.36.49-.13.04-.27.03-.4,0-.08-.02-.15-.07-.21-.13-.08-.09-.11-.19-.11-.3Z"
        />
        <path
          strokeWidth={0}
          d="M18.91,5.92c-.1,0-.18-.08-.18-.18,0-.1.08-.18.18-.18.1,0,.18.08.18.18,0,.1-.08.18-.18.18Z"
        />
      </svg>
    );
  },
);

export default Nextjs;
